import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import 'react-dom';
import './chunk-0cd02bff.js';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-061cef7c.js';
import './chunk-22b2fb47.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 998;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -moz-tap-highlight-color: rgba(0, 0, 0, 0);\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Backdrop = styled(Hidden)(_templateObject(), theme("Backdrop"));
Backdrop.defaultProps = {
  role: "button",
  tabIndex: -1,
  opaque: true,
  palette: "shadow",
  tone: 2
};
var Backdrop$1 = use(Backdrop, "div");
export default Backdrop$1;